/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MonthlyAchievementType {
    TOP_WRITER = 'TOP_WRITER',
    RISING_CREATOR = 'RISING_CREATOR',
    MOST_LOVE = 'MOST_LOVE',
}
